// // SUBMENU mobile funcionality
const allSubMenus = [];
document.addEventListener('DOMContentLoaded', getMobileNavItemsWithChildren);
function getMobileNavItemsWithChildren(){
    const navItemsWithChildren = document.querySelectorAll('#mobile-navigation .menu-item-has-children');
    if (navItemsWithChildren){
        navItemsWithChildren.forEach((navItem)=>{
            // listen for clicks
            navItem.addEventListener('click', toggleSubMenu);
            const submenu = navItem.querySelector('.sub-menu');
            submenu.style.height = `${submenu.offsetHeight}px`;
            submenu.classList.add('hidden');
            allSubMenus.push(submenu);
        })
    }
}
function toggleSubMenu(e){
    if(e.target.closest('.sub-menu')){
        return
    }
    e.preventDefault();
    const clickedElement = e.target.closest('.menu-item-has-children');
    const subMenu = clickedElement.querySelector('.sub-menu');

    closeOtherOpenSubs(subMenu)
    clickedElement.classList.toggle('open');
    subMenu.classList.toggle('hidden');
}
function closeOtherOpenSubs(targetedMenu){
    allSubMenus.forEach((submenu)=>{
        if(submenu !== targetedMenu){
            submenu.classList.add('hidden');
            submenu.closest('.menu-item-has-children').classList.remove('open');
            console.log('other link', submenu.closest('.menu-item-has-children'));
        }
    })
}